var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.items.length > 0)?_c('div',[_c('VueSlickCarousel',{staticClass:"mt-3",attrs:{"arrows":false,"dots":true,"slidesToScroll":1,"slidesToShow":3,"responsive":[
			{
				breakpoint: 1720,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 1400,
				settings: {
					slidesToShow: 3,
				},
			},
			{
				breakpoint: 991,
				settings: {
					slidesToShow: 2,
				},
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 1,
				},
			} ]}},[_vm._l((_vm.items),function(item){return [_c('ProductItem',{key:item.id,attrs:{"item":item}})]})],2)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }